import React, { useState } from "react"
import FolderSharedIcon from "@mui/icons-material/FolderShared"
import Box from "@mui/material/Box"
import IconButton from "@mui/material/IconButton"
import { useKeycloak } from "@react-keycloak/web/lib/useKeycloak"
import { useNavigate, useSearchParams } from "react-router-dom"
import Container from "@mui/material/Container"
import AppBar from "@mui/material/AppBar"
import Toolbar from "@mui/material/Toolbar"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"

import ExitToAppIcon from "@mui/icons-material/ExitToApp"

import Skeleton from "@mui/material/Skeleton"

import ToggleButton from "@mui/material/ToggleButton"
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup"
import { useGetAllInterviewsQuery } from "../../entities/hiring/api/InterviewsApi"

import { useSelector } from "react-redux"
import { RootState } from "../../app/store"
import { ApiUrl, baseQuery, baseUrl } from "../../shared/api/baseQuery"

const Header = () => {
  const { keycloak } = useKeycloak()

  const ToggleButtons = [
    { title: "Самокат", value: "smkt", color: "#FF335F", disabled: false },
    { title: "Мегамаркет", value: "mm", color: "#6933B0", disabled: true },
  ]

  const [departament, setDepartament] = useState("smkt")

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newDepartament: string,
  ) => {
    if (newDepartament !== null) {
      setDepartament(newDepartament)
    }
  }

  const url = baseUrl

  return (
    <>
      <AppBar
        position="static"
        sx={{
          backgroundColor: (theme) => "background.paper",
          py: "4px",
        }}
        elevation={0}
      >
        <Container disableGutters maxWidth="lg">
          <Toolbar disableGutters variant="dense">
            {keycloak.authenticated ? (
              <Typography
                variant="h6"
                component="div"
                sx={{
                  textAlign: "flex-start",
                  fontWeight: "bold",

                  flexGrow: 1,
                  color:
                    baseUrl === ApiUrl.baseUrl.toString()
                      ? "text.primary"
                      : "#FF335F",
                  ml: "10px",
                }}
              >
                {baseUrl === ApiUrl.baseUrl.toString() &&
                  " Найм операторов в поддержку "}
                {baseUrl === ApiUrl.testUrl.toString() &&
                  " Найм операторов в поддержку (ТЕСТОВЫЙ СТЕНД) "}
              </Typography>
            ) : (
              <Stack
                direction={"row"}
                alignItems={"center"}
                justifyContent={"center"}
                sx={{ flexGrow: 1 }}
                width={"100%"}
              >
                <Skeleton
                  variant="text"
                  sx={{ fontSize: "1.25rem", width: "400px" }}
                />
              </Stack>
            )}
            {keycloak.authenticated && (
              <Stack
                sx={{}}
                direction={"row"}
                alignItems={"center"}
                spacing={1}
              >
                <ToggleButtonGroup
                  color="primary"
                  value={departament}
                  exclusive
                  onChange={handleChange}
                  aria-label="Platform"
                  size="small"
                  sx={{
                    ".MuiToggleButton-root": {
                      textTransform: "none",
                      fontSize: "14px",
                      fontWeight: "bold",

                      height: "25px",
                      color: departament !== "smkt" ? "#FF335F" : "#6933B0",
                      border: `1px solid ${
                        departament === "smkt"
                          ? "#6933B0"
                          : departament === "mm"
                          ? "#FF335F"
                          : "#FF335F"
                      }`,
                    },
                  }}
                >
                  {ToggleButtons.map((button) => (
                    <ToggleButton
                      disabled={button.disabled}
                      sx={{
                        "&.Mui-selected": {
                          bgcolor: `${button.color} !important`,
                          color: "white !important",

                          border: `1px solid ${
                            departament === "smkt"
                              ? "#FF335F"
                              : departament === "mm"
                              ? "#6933B0"
                              : "#FF335F"
                          } !important`,
                        },
                      }}
                      value={button.value}
                      key={button.value}
                    >
                      {button.title}
                    </ToggleButton>
                  ))}
                </ToggleButtonGroup>

                <IconButton
                  edge="start"
                  color="default"
                  aria-label="menu"
                  sx={{
                    color: (theme) =>
                      theme.palette.mode === "dark"
                        ? "rgba(242, 242, 242, 0.5) "
                        : "rgba(23, 23, 23, 0.5",
                    border: "none",
                    height: "25px",
                  }}
                  onClick={() => keycloak.logout()}
                >
                  <ExitToAppIcon sx={{ height: "25px" }} fontSize="inherit" />
                </IconButton>
              </Stack>
            )}
          </Toolbar>
        </Container>
      </AppBar>
    </>
  )
}

export default Header
